"use client";

import { c as _c } from "react/compiler-runtime";
import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui";
export default function ExternalIdField(t0) {
  const $ = _c(10);
  const {
    className,
    required: t1
  } = t0;
  const required = t1 === undefined ? false : t1;
  const {
    register,
    formState: t2
  } = useFormContext();
  const {
    errors
  } = t2;
  const t3 = required && "External ID is required";
  let t4;
  if ($[0] !== register || $[1] !== t3) {
    t4 = register("externalId", {
      required: t3
    });
    $[0] = register;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = !!errors.externalId;
  const t6 = String(errors.externalId?.message) || undefined;
  let t7;
  if ($[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
    t7 = <Input type="text" id="externalId" className="mt-1" {...t4} hasError={t5} errorMessage={t6} />;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== className || $[8] !== t7) {
    t8 = <div className={className}>{t7}</div>;
    $[7] = className;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}